import { render, staticRenderFns } from "./AbaHomologarEdital.vue?vue&type=template&id=3ea9a09b&scoped=true"
import script from "./AbaHomologarEdital.vue?vue&type=script&lang=ts"
export * from "./AbaHomologarEdital.vue?vue&type=script&lang=ts"
import style0 from "./AbaHomologarEdital.vue?vue&type=style&index=0&id=3ea9a09b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea9a09b",
  null
  
)

export default component.exports